import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgInfoFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm1-14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 4v4a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0Z", fill: color }));
};
export default factorySvgIcon(SvgInfoFilled);
//# sourceMappingURL=SvgInfoFilled.js.map